
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Pune',
        heading: 'Platinum24 Cabs: Urbania On Rent in Pune',
        headingDescription: ' Platinum24 Cabs provides premium Urbania on Rent in Pune, perfect for luxury group travel, corporate tours, family vacations, and long-distance journeys. Our Urbania vans come with modern interiors, push-back seating, powerful air-conditioning, and extra luggage space to make your trip comfortable and stylish. With professional chauffeurs, timely service, and flexible rental packages, we ensure a smooth travel experience for groups of all sizes. Whether it’s a weekend getaway, a pilgrimage yatra, or a business trip, Platinum24 Cabs’ Urbania rental service guarantees safety, reliability, and unmatched comfort on every journey.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort palace. Once the seat of the Maratha Empire, its massive gates, fountains, and ruins narrate tales of grandeur. Though destroyed by fire in 1828, it still draws thousands of visitors. The evening light-and-sound show recreates the legacy of Bajirao and Mastani. Tourists love exploring its historic courtyards and gardens. Shaniwar Wada is Pune’s proud heritage symbol."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s belongings and photographs. The Italian arches and sprawling lawns add architectural beauty. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historical and inspirational landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. The fort offers trekking trails, temples, and panoramic views of the Sahyadris. In monsoon, mist and waterfalls make the climb enchanting. Visitors also enjoy local delicacies like pithla-bhakri at the fort. It is a blend of adventure and history. Sinhagad is Pune’s must-visit trekking and heritage spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the center of grand festivities with thousands of devotees. The temple is also known for its charitable activities. It is a spiritual and cultural icon of the city. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and spirituality. Its architecture reflects ancient Indian craftsmanship. Evening chants create a mystical aura. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. The recreated Mastani Mahal is a highlight. It is an educational and fascinating spot for history enthusiasts. The museum preserves Indian traditions across centuries. It is Pune’s cultural treasure house."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At its summit stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Climbing 103 steps to the top is both devotional and adventurous. Sunrise and sunset views here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center for wellness and spirituality. Spread across lush gardens, it attracts seekers worldwide. It offers meditation, yoga sessions, and personal growth workshops. The ashram’s Zen gardens and serene meditation halls provide tranquility. It is ideal for rejuvenation and mindfulness. Osho Ashram is Pune’s international hub of peace and harmony."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns make it a peaceful retreat. Families enjoy strolls, photography, and picnics here. The garden represents Indo-Japanese cultural friendship. Seasonal flowers enhance its beauty year-round. Pu La Deshpande Garden is Pune’s green oasis of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend destination near Pune. It supplies water to the city while offering picturesque landscapes. During monsoon, the overflowing dam becomes a spectacular sight. Street food stalls selling corn and tea make it lively. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway."
  }
],



   "services": [
    {
      "name": "Urbania Car Rental Pune",
      "description": "Experience reliable and hassle-free Urbania car rental services in Pune, perfect for city commutes, weekend getaways, or business trips. Our fleet includes well-maintained Urbania cars that offer a perfect blend of comfort, fuel efficiency, and style. Whether you need a short-term rental or long-term use, our flexible packages cater to all your transportation needs, ensuring a smooth and enjoyable driving experience."
    },
    {
      "name": "Urbania On Rent Pune",
      "description": "Convenient Urbania car rental on rent in Pune with flexible duration options including hourly, daily, and weekly rentals. Ideal for individuals and families who want a comfortable and affordable ride. All our Urbania cars come with regular maintenance checks, comprehensive insurance, and prompt roadside assistance for peace of mind during your rental period."
    },
    {
      "name": "Rent Urbania Car Pune",
      "description": "Rent an Urbania car in Pune with ease through our streamlined booking process. Choose from a variety of rental plans to suit your schedule and budget. Perfect for local sightseeing, airport transfers, or corporate travel, our Urbania rentals offer excellent mileage, comfortable interiors, and safety features to ensure a worry-free journey around Pune and beyond."
    },
    {
      "name": "Pune Urbania Booking",
      "description": "Book your Urbania car rental in Pune instantly via our user-friendly online platform or phone support. Enjoy instant confirmation, multiple pickup and drop-off points, and customized rental durations. Our dedicated customer service team is available 24/7 to assist you with any queries, ensuring that your car rental experience is smooth, transparent, and convenient."
    },
    {
      "name": "Affordable Urbania Rental Pune",
      "description": "Get the best value for money with our affordable Urbania rental services in Pune. We provide competitive pricing without compromising on vehicle quality or service standards. Our transparent pricing model includes all taxes, insurance, and additional fees upfront, making it easier for you to plan your budget for local travel, airport transfers, or outstation trips."
    },
    {
      "name": "Urbania Car Hire Pune",
      "description": "Professional Urbania car hire services in Pune, offering both self-drive and chauffeur-driven options. Whether you prefer the freedom to drive yourself or want a skilled driver to take the wheel, our fleet is maintained to the highest standards to guarantee comfort, safety, and timely service. Perfect for corporate clients, tourists, and locals alike."
    },
    {
      "name": "Pune Urbania Taxi Service",
      "description": "Reliable Urbania taxi services in Pune with verified drivers and well-maintained vehicles for your daily commute or special occasions. Our taxi service offers flexible booking options, fixed rates, and a commitment to punctuality and customer satisfaction. Experience a comfortable ride with courteous drivers who prioritize your safety and convenience."
    },
    {
      "name": "Urbania Self Drive Pune",
      "description": "Explore Pune on your own terms with Urbania self-drive rental options. Our self-drive Urbania cars are regularly inspected and sanitized, equipped with modern features, and available at competitive prices. Enjoy the freedom of independent travel without worrying about fuel efficiency or maintenance, as we take care of all vehicle servicing and roadside support."
    },
    {
      "name": "Urbania Car Rent with Driver Pune",
      "description": "Opt for Urbania car rentals with professional drivers in Pune to ensure a stress-free and comfortable journey. Our drivers are trained, courteous, and well-acquainted with Pune’s roads, traffic conditions, and routes. Whether it’s airport transfers, corporate travel, or city tours, our driver-driven service offers convenience and reliability for every trip."
    },
    {
      "name": "Urbania Car Rental Deals Pune",
      "description": "Take advantage of exclusive Urbania car rental deals and discounts in Pune. We offer seasonal promotions, long-term rental offers, and customized packages to give you the best value for your money. Stay updated with our latest deals to enjoy premium car rentals at budget-friendly prices, perfect for frequent travelers and corporate clients."
    },
    {
      "name": "Urbania Car Rental for Local Trips Pune",
      "description": "Perfect for local Pune trips, our Urbania car rental service offers comfortable rides for sightseeing, family outings, shopping, and daily errands. Our vehicles are fuel-efficient and easy to maneuver in city traffic, ensuring you reach your destinations on time without any hassle. Flexible rental durations and easy booking make local travel convenient and affordable."
    },
    {
      "name": "Urbania Taxi Booking Pune",
      "description": "Book your Urbania taxi in Pune effortlessly via our online platform or phone service. We offer instant booking confirmation, real-time vehicle tracking, and multiple payment options for a hassle-free experience. Our taxis are available round the clock to cater to your urgent travel needs, ensuring safety, punctuality, and comfort at all times."
    },
    {
      "name": "Urbania Rental for Airport Transfer Pune",
      "description": "Reliable and punctual Urbania car rentals for airport transfers in Pune, designed to ensure you reach the airport or your destination on time. Our service includes comfortable waiting areas, flight monitoring to adjust pickup times, and professional drivers familiar with airport procedures. Travel stress-free to and from Pune airport with our trusted rental service."
    },
    {
      "name": "Pune Urbania Rental Offers",
      "description": "Exclusive rental offers for Urbania cars in Pune, including discounts on weekend rentals, long-duration hires, and corporate packages. Our flexible offers help you save more while enjoying premium-quality vehicles. Subscribe to our newsletter or follow us on social media to never miss out on these attractive deals and maximize your rental benefits."
    },
    {
      "name": "Pune Urbania Car Rental Packages",
      "description": "Customizable Urbania car rental packages in Pune catering to diverse travel needs such as daily commute, weekend trips, corporate travel, and special events. Packages include options for self-drive or chauffeur-driven services, with add-ons like GPS, extra driver allowance, and comprehensive insurance. Our transparent pricing and tailored packages ensure you get the best service within your budget."
    }
  ],
  "tableData": [
    ["Urbania Car Rental Pune", "Urbania On Rent Pune"],
    ["Rent Urbania Car Pune", "Pune Urbania Booking"],
    ["Affordable Urbania Rental Pune", "Urbania Car Hire Pune"],
    ["Pune Urbania Taxi Service", "Urbania Self Drive Pune"],
    ["Urbania Car Rent with Driver Pune", "Urbania Car Rental Deals Pune"],
    ["Urbania Car Rental for Local Trips Pune", "Urbania Taxi Booking Pune"],
    ["Urbania Rental for Airport Transfer Pune", "Pune Urbania Rental Offers"],
    ["Pune Urbania Car Rental Packages", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Premium Urbania on Rent in Pune for Group Travel",
      "WhyChoosedescription": "Platinum24 Cabs offers stylish and spacious Urbania vans, perfect for comfortable group journeys in and around Pune."
    },
    {
      "WhyChooseheading": "Ideal for Corporate Events, Family Trips, and Outstation Tours",
      "WhyChoosedescription": "Our Urbania rental service suits all types of group travel needs—be it business or leisure."
    },
    {
      "WhyChooseheading": "Spacious Interiors with Luxury Seating",
      "WhyChoosedescription": "Experience the ultimate travel comfort with plush seats, ample legroom, and modern interiors in every Urbania."
    },
    {
      "WhyChooseheading": "Multiple Seating Capacities to Fit Your Group Size",
      "WhyChoosedescription": "Choose the right Urbania variant that matches your group’s size and luggage needs."
    },
    {
      "WhyChooseheading": "Fully AC Vehicles with Entertainment System",
      "WhyChoosedescription": "Enjoy a relaxed ride with air conditioning, music system, and USB charging ports onboard."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs for a Safe Journey",
      "WhyChoosedescription": "Our trained and courteous drivers ensure a safe, timely, and smooth ride throughout your trip."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vans",
      "WhyChoosedescription": "Each Urbania is thoroughly cleaned and inspected before every trip to maintain hygiene and comfort."
    },
    {
      "WhyChooseheading": "Transparent Pricing and Easy Booking Process",
      "WhyChoosedescription": "Get competitive rental rates with no hidden charges, and book effortlessly via call or online."
    }
  ]




















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Urbania car rentals in Pune?',
        answer: 'Yes, Platinum24 Cabs provides Urbania car rentals in Pune for comfortable and stylish travel.',
    },
    {
        question: 'How can I book an Urbania car on rent in Pune with Platinum24 Cabs?',
        answer: 'You can easily book an Urbania car through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What are the features of the Urbania car available for rent?',
        answer: 'The Urbania offers spacious interiors, modern amenities, and fuel-efficient performance, perfect for city and outstation travel.',
    },
    {
        question: 'Are the Urbania cars well-maintained and clean?',
        answer: 'Yes, all Urbania cars are regularly serviced, cleaned, and sanitized to ensure a comfortable ride.',
    },
    {
        question: 'Can I rent an Urbania car for hourly, daily, or long-term use in Pune?',
        answer: 'Absolutely! We offer flexible rental packages including hourly, daily, and multi-day options to suit your needs.',
    },
    {
        question: 'Do Urbania rentals come with a driver?',
        answer: 'Yes, all rentals include professional and experienced drivers for your convenience and safety.',
    },
    {
        question: 'Can I customize pickup and drop-off locations when renting an Urbania in Pune?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points for a hassle-free experience.',
    },
    {
        question: 'Are safety protocols followed for Urbania car rentals?',
        answer: 'Yes, our vehicles are regularly sanitized, and drivers follow strict safety and hygiene guidelines.',
    },
    {
        question: 'Is corporate Urbania rental available in Pune?',
        answer: 'Yes, we offer customized corporate rental solutions for Urbania cars with priority support and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Aditya Kulkarni',
        feedback: 'The Urbania rental service from Platinum24 Cabs was excellent. The car was clean and the driver professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rhea Sharma',
        feedback: 'I had a great experience renting an Urbania car in Pune. The booking was smooth and the ride very comfortable.',
        rating: 5,
    },
];


































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const urbaniaOnRentPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune",
  "image": "https://www.platinum24cab.com/assets/images/urbania-car-rental-pune.jpg",
  "description": "Rent Urbania cars in Pune for local trips, airport transfers, and corporate use. Affordable Urbania car hire with self-drive and chauffeur-driven options at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/urbania-on-rent-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Urbania On Rent in Pune | Affordable Urbania Car Rental | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Rent Urbania cars in Pune for local trips, airport transfers, and corporate use. Affordable Urbania car hire with self-drive and chauffeur-driven options at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Urbania Car Rental Pune, Urbania On Rent Pune, Rent Urbania Car Pune, Pune Urbania Booking, Affordable Urbania Rental Pune, Urbania Car Hire Pune, Pune Urbania Taxi Service, Urbania Self Drive Pune, Urbania Car Rent with Driver Pune, Urbania Car Rental Deals Pune, Urbania Car Rental for Local Trips Pune, Urbania Taxi Booking Pune, Urbania Rental for Airport Transfer Pune, Pune Urbania Rental Offers, Pune Urbania Car Rental Packages"
  />
  <script type="application/ld+json">
    {JSON.stringify(urbaniaOnRentPuneSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpune;